export default __webpack_public_path__ + "static/media/NYC2x.e3f9bfa9.png";